<template>
  <b-modal
    v-model="localShow"
    title="Filtros"
    hide-footer
    centered
    @hide="$emit('close')"
  >
    <b-form>
      <b-form-group label="Tipo">
        <b-form-select
          v-model="localFilters.type"
          :options="typeOptions"
        />
      </b-form-group>

      <b-form-group label="Fonte">
        <b-form-select 
        v-model="localFilters.source"
         :options="sourceOptions" />
      </b-form-group>

      <b-form-group label="Motivo">
        <b-form-select
          v-model="localFilters.reason"
          :options="reasonOptions"
        />
      </b-form-group>

      <b-form-group 
        v-if="localFilters.reason.startsWith('OUTROS')"
        label="Digite o motivo"
      >
        <b-form-input
          v-model="localFilters.customReason"
          placeholder="Informe o motivo"
        />
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="secondary" class="mr-2" @click="clear">
          Limpar
        </b-button>
        <b-button variant="primary" @click="apply">
          Aplicar
        </b-button>
      </div>

    </b-form>
  </b-modal>
</template>

<script>
import BlacklistService from '@/service/blacklist'
import {
  BModal, BForm, BFormGroup,
  BFormInput, BFormSelect, BButton
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton
  },

  props: {
    show: Boolean,
    filters: Object
  },

  data() {
    return {
      localShow: this.show,
      localFilters: { ...this.filters },
      reasons: [],
       typeOptions: [
      { value: '', text: 'Selecione um tipo' },
      { value: 'PF', text: 'Pessoa Física (PF)' },
      { value: 'PJ', text: 'Pessoa Jurídica (PJ)' }
    ],
     sourceOptions: [
      { value: '', text: 'Selecione uma fonte' },
      { value: 'SOULPAY', text: 'SOULPAY' },
      { value: 'VIAINVEST', text: 'VIAINVEST' }
    ]
    }
  },

  watch: {
    show(val) {
      this.localShow = val

      if (val) {
        this.fetchReasons()
      }
    }
  },

  computed: {
    reasonOptions() {
      return [
        { value: '', text: 'Selecione um motivo' },
        ...this.reasons.map(r => ({
          value: r,
          text: r
        }))
      ]
    }
  },
  
  methods: {
    apply() {
      const filters = {
        ...this.localFilters,
        reason: this.localFilters.reason.startsWith('OUTROS')
          ? this.localFilters.customReason
          : this.localFilters.reason
      }

      this.$emit('apply', filters)
      this.$emit('close')
    },

      async fetchReasons() {
        try {
          const response = await BlacklistService.getReasons()
          this.reasons = response.data || []

        } catch (error) {
          console.error('Erro ao buscar motivos:', error)
        }
      },

    clear() {
      const empty = {
        search: '',
        type: '',
        source: '',
        reason: '',
        customReason: ''
      }
      this.localFilters = empty
      this.$emit('apply', empty)
    }
  }
}
</script>